// extracted by mini-css-extract-plugin
export default {"page":"OQ","headerwrap":"PQ","headerblock":"QQ","textwrapper":"RQ","text":"SQ","closerlook":"TQ","arrowwrap":"UQ","icon":"VQ","updown":"WQ","products":"XQ","system":"YQ","systemimage":"ZQ","cards":"aR","note":"bR","fadein":"cR"};
    if(module.hot) {
      // 1715276859162
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  